<template>
  <div class="actions-collapsed-list">
    <button
      class="btn btn-function exit-collapsed-list"
      @click="collapseActions"
    >
      <i
        v-tooltip.right.hover="$t('CANCEL')"
        class="glyphicon glyphicon-chevron-left"
        aria-hidden="true"
      />
    </button>

    <div class="action-icon">
      <button
        data-testid="edit-integration-button"
        class="btn btn-list-function"
        @click="showForm"
      >
        <i
          v-tooltip.right.hover="$t('EDIT')"
          class="typcn typcn-edit"
          aria-hidden="true"
        />
        <span v-t="'EDIT'" class="hint-text-mobile" />
      </button>
    </div>

    <div
      v-if="showRefreshButton"
      class="action-icon"
    >
      <button
        class="btn btn-list-function"
        :disabled="isRefreshDisabled"
        @click="refreshToken"
      >
        <i
          v-tooltip.right.hover="$t('REFRESH_TOKEN')"
          class="typcn typcn-arrow-sync"
          aria-hidden="true"
        />
        <span v-t="'REFRESH_TOKEN'" class="hint-text-mobile" />
      </button>
    </div>

    <div class="action-icon">
      <button
        class="btn btn-list-function"
        :disabled="disabled"
        :aria-label="enabledButtonLabel"
        @click="toggleEnabled"
      >
        <i
          :class="enabledIconClass"
          v-tooltip.right.hover="enabledButtonLabel"
          aria-hidden="true"
        />
        <span class="hint-text-mobile">{{ enabledButtonLabel }}</span>
      </button>
    </div>

    <div class="action-icon">
      <button
        data-testid="delete-icon"
        @click="deleteIntegration"
        :disabled="disabled"
        class="btn btn-list-function"
      >
        <i
          class="typcn typcn-trash"
          v-tooltip.right.hover="$t('DELETE')"
          aria-hidden="true"
        ></i>
        <span class="hint-text-mobile" v-t="'DELETE'"> </span>
      </button>
    </div>
    <ChangeLogObjectButtonAction
      :is-disabled="disabled"
      :object-id="integration.id"
      :object-name="integration.name"
      object-type="integration"
    />
  </div>
</template>

<script>
import ChangeLogObjectButtonAction from '@/core/components/ChangeLog/ChangeLogObjectButtonAction';
import messages from '../locales';
import sharedMessages from '@/core/locales';
const FACEBOOK_TYPES = ['facebook', 'facebookEvents'];

export default {
  name: 'PlatformActions',
  components: {
    ChangeLogObjectButtonAction,
  },
  props: {
    integration: {
      type: Object,
      required: true,
      validator(value) {
        return value && typeof value.id === 'string';
      },
      default() {
        return {};
      },
    },
    integrationToReset: {
      type: Object,
      default() {
        return null;
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showRefreshButton() {
      return FACEBOOK_TYPES.includes(this.integration.type) && this.integration.status !== 'Pending';
    },
    isRefreshDisabled() {
      return this.disabled || this.integrationToReset;
    },
    enabledButtonLabel() {
      return this.integration.enabled ? this.$t('ENABLED') : this.$t('PAUSED');
    },
    enabledIconClass() {
      return {
        'typcn': true,
        'typcn-media-pause': this.integration.enabled,
        'typcn-media-play': !this.integration.enabled
      };
    }
  },
  methods: {
    deleteIntegration() {
      this.$emit('deleteIntegration', this.integration);
    },
    refreshToken() {
      this.$emit('refreshIntegration', this.integration);
    },
    toggleEnabled() {
      this.$emit('toggleEnabled', this.integration);
    },
    showForm() {
      this.$emit('editIntegration', this.integration);
    },
    collapseActions() {
      this.$emit('collapseActions', this.integration);
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
};
</script>
